import React from 'react';
import { LanguageProvider } from './src/context/LanguageContext';
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import './src/styles/global.css';

export const wrapRootElement = ({ element }) => (
  <LanguageProvider>{element}</LanguageProvider>
);

// Clean up any previously registered service workers (e.g., from offline plugin)
export const onClientEntry = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations?.()
      .then((regs) => regs.forEach((reg) => reg.unregister().catch(() => {})))
      .catch(() => {});
    navigator.serviceWorker.getRegistration?.()
      .then((reg) => reg?.unregister?.().catch(() => {}))
      .catch(() => {});
  }
};
